import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * EL MISMO PACIENTE EN DOS SITIOS A LA VEZ (23/9/2026)
 * ----------------------------------------------------
 * Una paciente tenía dos citas activas el 24/9 a las 12:30, una en
 * «Quirófano Blefaroplastia» y otra en «Quirófano Rinoplastia», y el parte del
 * día la pintaba en los dos quirófanos sin más. Dirección: «o está en un
 * quirófano o está en otro. No puede ser ambos».
 *
 * Desde hoy el servidor no deja darlas (409 sin «Forzar»), pero las que ya
 * existen siguen ahí: el listado de citas marca cada una con `duplicada_en`
 * (la otra cita: agenda, hora, id) y aquí se dice en rojo, con la salida.
 * Quién decide si hay duplicado es el servidor, no esta pantalla.
 *
 * Es un <span> y no un <div> porque en el parte del día va DENTRO del botón
 * que despliega la fila del paciente.
 *
 * Con el NOMBRE del paciente y no «Esta paciente» (supervisor, 23/9/2026):
 * con un paciente varón se leía mal, y el nombre dice además de quién es sin
 * mirar arriba. «Tiene cita» en vez de «está citada», por lo mismo.
 */
export function textoCitaDuplicada(duplicada, nombre) {
  if (!duplicada) return '';
  const hora = duplicada.hora ? ` a las ${duplicada.hora}` : '';
  const donde = duplicada.agenda || 'otra agenda';
  const quien = (nombre || '').trim();
  return quien
    ? `${quien} también tiene cita${hora} en ${donde}: anula la que sobra.`
    : `También tiene cita${hora} en ${donde}: anula la que sobra.`;
}

export default function CitaDuplicadaAviso({ duplicada, nombre, testId = 'cita-duplicada', className = '' }) {
  if (!duplicada) return null;
  return (
    <span
      role="alert"
      className={`flex items-start gap-1.5 rounded-md border border-red-300 bg-red-50 px-2 py-1.5 text-[13px] font-medium text-red-800 ${className}`}
      data-testid={testId}
      data-cita-id={duplicada.cita_id || ''}
    >
      <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5 text-red-600" aria-hidden="true" />
      <span>{textoCitaDuplicada(duplicada, nombre)}</span>
    </span>
  );
}
